var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C8.45632 0 7.18496 1.16592 7.01847 2.66519C4.64457 3.78441 3 6.19907 3 9V11C1.34315 11 0 12.3431 0 14C0 15.6569 1.34315 17 3 17H17C18.6569 17 20 15.6569 20 14C20 12.3431 18.6569 11 17 11V9C17 6.19907 15.3554 3.78442 12.9815 2.6652C12.815 1.16592 11.5437 0 10 0ZM9 3C9 2.44772 9.44772 2 10 2C10.5523 2 11 2.44772 11 3C11 3.05764 10.9952 3.1134 10.9863 3.16711C10.906 3.64768 11.1838 4.11614 11.644 4.27626C13.5992 4.95661 15 6.816 15 9V12C15 12.5523 15.4477 13 16 13H17C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17 15H3C2.44772 15 2 14.5523 2 14C2 13.4477 2.44772 13 3 13H4C4.55228 13 5 12.5523 5 12V9C5 6.816 6.40085 4.95661 8.35604 4.27626C8.8162 4.11614 9.09398 3.64768 9.01374 3.16711C9.00477 3.1134 9 3.05764 9 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C8.34315 18 7 19.3431 7 21C7 22.6569 8.34315 24 10 24C11.6569 24 13 22.6569 13 21C13 19.3431 11.6569 18 10 18ZM9 21C9 20.4477 9.44772 20 10 20C10.5523 20 11 20.4477 11 21C11 21.5523 10.5523 22 10 22C9.44772 22 9 21.5523 9 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.239fea6e96988ab6d98cdd509cfc1099.svg";
export { ForwardRef as ReactComponent };